export const buildGoogleOverwritedRedirectionUrl = (activeWrapper, redirectionUrl, currentUrl) => activeWrapper === 'page'
    ? redirectionUrl || '/'
    : redirectionUrl || currentUrl;
//# sourceMappingURL=buildGoogleOverwritedRedirectionUrl.js.map